module.exports = __webpack_public_path__ + "static/media/innocent-1.504892e4.png";